
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambassador",
      function () {
        return require("private-next-pages/ambassador/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambassador"])
      });
    }
  